import { render, staticRenderFns } from "./uiSettings.vue?vue&type=template&id=9ba4ef36"
import script from "./uiSettings.vue?vue&type=script&lang=ts"
export * from "./uiSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports